import React from 'react';
import { useTranslation } from 'react-i18next';
import OpArticle, { ArticleSection } from '../components/optimus/OpArticle';

interface NOTEoriousAppPageProps {
  darkMode: boolean;
}

const CODE_PUBSPEC = `# pubspec.yaml
dependencies:
  flutter:
    sdk: flutter
  camera: ^0.10.5
  image_picker: ^0.8.7
  firebase_core: ^2.13.0
  firebase_auth: ^4.6.1
  cloud_firestore: ^4.7.1
  google_ml_kit: ^0.13.0`;

const CODE_API = `// Express.js notes endpoint
app.post('/api/notes', authenticate, async (req, res) => {
  try {
    const note = new Note({
      userId: req.user.id,
      title: req.body.title,
      content: req.body.content,
      ocrText: req.body.ocrText,
      createdAt: new Date(),
    });
    await note.save();
    res.status(201).json(note);
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});`;

const NOTEoriousAppPage: React.FC<NOTEoriousAppPageProps> = ({ darkMode }) => {
  const { t } = useTranslation();
  const b = 'op.blog.note';

  const sections: ArticleSection[] = [
    { title: t(`${b}.s1t`), paragraphs: [t(`${b}.s1p1`)] },
    {
      title: t(`${b}.s2t`),
      paragraphs: [t(`${b}.s2p1`)],
      code: { filename: 'pubspec.yaml', content: CODE_PUBSPEC },
    },
    { title: t(`${b}.s3t`), paragraphs: [t(`${b}.s3p1`)] },
    {
      title: t(`${b}.s4t`),
      paragraphs: [t(`${b}.s4p1`)],
      code: { filename: 'server/routes/notes.js', content: CODE_API },
    },
    { title: t(`${b}.s5t`), paragraphs: [t(`${b}.s5p1`)] },
  ];

  const takeaways = [1, 2, 3, 4].map((n) => ({
    title: t(`${b}.k${n}t`),
    description: t(`${b}.k${n}d`),
  }));

  return (
    <OpArticle
      darkMode={darkMode}
      slug="noteorious-app-development"
      category={t(`${b}.category`)}
      title={t('blogPosts.noteoriousAppDevelopment.title')}
      description={t('blogPosts.noteoriousAppDevelopment.description')}
      date="2025-05-18"
      readingTime={6}
      tags={['Flutter', 'OCR', 'LexifAI', 'Mobile', 'Senior Design']}
      seoKeywords="NOTEorious app development, Flutter AI integration, OCR mobile app, handwriting recognition, computer engineering capstone"
      sections={sections}
      takeaways={takeaways}
    />
  );
};

export default NOTEoriousAppPage;
